import { render, staticRenderFns } from "./DownloadCard.vue?vue&type=template&id=856d1f14&scoped=true&"
import script from "./DownloadCard.vue?vue&type=script&lang=js&"
export * from "./DownloadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856d1f14",
  null
  
)

export default component.exports